<template>
  <Head>
    <Link
      rel="icon"
      type="image/x-icon"
      href="/favicon.png" />
  </Head>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
  usePlausible()
</script>
